// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1y4Dx","inputWrap":"styles_inputWrap__29tx3","input":"styles_input__3HS0v"};